// @ts-strict-ignore
import type { Dispatch, MutableRefObject, SetStateAction } from 'react';
import type { KeyboardFocus, MultiSelectProps } from '@usealloy/component-library';
import { createContext } from 'react';
import type { AggregationConfig, AggregationSourceData, AggregationValidationErrors } from './types';

export type AggregationEditorContextType = {
  sourceData: AggregationSourceData;
  setSourceData: Dispatch<SetStateAction<AggregationSourceData>>;
  handleSave: () => void;
  handleCancel: () => void;
  /** Ref for the aggregation editor root container; used for keyboard focus scope (mirrors MLA mlaEditorPanelBoxContainerRef). */
  aggregationEditorContainerRef: MutableRefObject<HTMLDivElement | null>;
  /** Shared MultiSelect presentation props (preview state, disabled state, etc.). */
  multiSelectProps: Partial<MultiSelectProps>;
  /** Resolved aggregation config for the current attribute (column options, filter options, etc.). */
  aggregationConfig: AggregationConfig;
  /** Whether the save/done button should be disabled (incomplete base fields or invalid filters). */
  isSaveDisabled: boolean;
  /** Validation errors keyed by field name; empty until a save attempt. */
  validationErrors: AggregationValidationErrors;
  keyboardFocus: KeyboardFocus | null;
};

export const AggregationEditorContext = createContext<AggregationEditorContextType>({
  sourceData: {} as AggregationSourceData,
  setSourceData: () => {},
  handleSave: () => {},
  handleCancel: () => {},
  aggregationEditorContainerRef: { current: null },
  multiSelectProps: {},
  aggregationConfig: {} as AggregationConfig,
  isSaveDisabled: true,
  validationErrors: {},
  keyboardFocus: null,
});
